/** Bildirimden hedef sayfaya giderken kullanılan arama query parametresi. */
export const REMINDER_SEARCH_QUERY = 'q';

/** Kalemin hedef sayfa aramasına yazılacak metni. */
export function reminderSearchFromItem(item: { searchText?: string; label?: string }): string {
  const direct = (item.searchText || '').trim();
  if (direct) return direct;

  const label = (item.label || '').trim();
  const sep = label.lastIndexOf(' — ');
  if (sep >= 0) {
    const tail = label.slice(sep + 3).trim();
    if (tail) return tail;
  }
  return label;
}

export function buildReminderHref(route: string, searchText?: string): string {
  const q = (searchText || '').trim();
  if (!q) return route;
  return `${route}?${REMINDER_SEARCH_QUERY}=${encodeURIComponent(q)}`;
}
